import './safari_banner_component.scss'
import { Controller } from 'stimulus'
import { inIframe, isMessageEvent } from 'iframe/helpers'

export default class extends Controller {
  static classes = ['show']

  connect = async (): Promise<void> => {
    const shouldShowNotice = this.showNotice && !(await this.hasSeenNotice())
    if (shouldShowNotice) {
      this.element.classList.add(this.showClass)
    }
  }

  close = (): void => {
    const message = {
      type: 'clara-setcookie',
      name: 'seenClaraSafariNotice',
      value: 'true'
    }
    window.parent.postMessage(message, '*')
    this.element.remove()
  }

  hasSeenNotice = async (): Promise<boolean> => {
    return await new Promise((resolve, reject) => {
      const onMessage = (e): void => {
        if (isMessageEvent(e, 'clara-cookievalue')) {
          window.removeEventListener('message', onMessage)
          resolve(e.data.value === 'true')
        }
      }
      window.addEventListener('message', onMessage)

      const message = {
        type: 'clara-getcookie',
        name: 'seenClaraSafariNotice'
      }
      window.parent.postMessage(message, '*')
    })
  }

  get isSafari (): boolean {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  }

  get showNotice (): boolean {
    return this.isSafari && inIframe()
  }
}
